module.exports = __webpack_public_path__ + "media/images/front/cards-afa1d63c276a9bcb641e8007ec22be9a.png";